import React from 'react';
import { TabProps } from './types';

const Tab6Preferences: React.FC<TabProps> = ({
  formData,
  updateNestedField,
}) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900">Section 6: Preferences</h3>

      {/* Feel & Sound Preferences */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Feel & Sound Preferences</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Feel Preference</label>
            <select
              value={formData.preferences?.feel_preference || ''}
              onChange={(e) => updateNestedField('preferences', {
                feel_preference: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="soft">Soft</option>
              <option value="medium">Medium</option>
              <option value="firm">Firm</option>
              <option value="very_firm">Very Firm</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Sound Preference</label>
            <select
              value={formData.preferences?.sound_preference || ''}
              onChange={(e) => updateNestedField('preferences', {
                sound_preference: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="muted">Muted</option>
              <option value="balanced">Balanced</option>
              <option value="crisp">Crisp</option>
              <option value="loud">Loud</option>
            </select>
          </div>
        </div>
      </div>

      {/* Visual & Design Preferences */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Visual & Design Preferences</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Visual Alignment Aids</label>
            <select
              value={formData.preferences?.visual_alignment_aids?.toString() || ''}
              onChange={(e) => updateNestedField('preferences', {
                visual_alignment_aids: e.target.value === 'true' ? true : e.target.value === 'false' ? false : undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Offset Preference</label>
            <select
              value={formData.preferences?.offset_preference || ''}
              onChange={(e) => updateNestedField('preferences', {
                offset_preference: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="none">None</option>
              <option value="slight">Slight</option>
              <option value="moderate">Moderate</option>
              <option value="significant">Significant</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Finish Style</label>
            <select
              value={formData.preferences?.finish_style || ''}
              onChange={(e) => updateNestedField('preferences', {
                finish_style: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="traditional">Traditional</option>
              <option value="modern">Modern</option>
              <option value="colorful">Colorful</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Grip Type Preference</label>
            <select
              value={formData.preferences?.grip_type_preference || ''}
              onChange={(e) => updateNestedField('preferences', {
                grip_type_preference: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="cord">Cord</option>
              <option value="rubber">Rubber</option>
              <option value="leather">Leather</option>
              <option value="midsize">Midsize</option>
            </select>
          </div>
        </div>
      </div>

      {/* Equipment Interests */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Equipment Interests & Biases</h4>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Clubs You Are Interested In</label>
            <textarea
              value={formData.preferences?.Clubs_you_are_interested_in || ''}
              onChange={(e) => updateNestedField('preferences', {
                Clubs_you_are_interested_in: e.target.value || undefined
              })}
              placeholder="Any biases/wants (e.g., Titleist, Callaway, specific models, etc.)"
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
              rows={2}
            />
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Clubs You Are Interested In (Looks)</label>
            <textarea
              value={formData.preferences?.Clubs_you_are_interested_in_looks || ''}
              onChange={(e) => updateNestedField('preferences', {
                Clubs_you_are_interested_in_looks: e.target.value || undefined
              })}
              placeholder="Any appearance/visual biases/wants"
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
              rows={2}
            />
          </div>
        </div>
      </div>

      {/* Material & Technology Preferences */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Material & Technology Preferences</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Materials Interested In (Irons)</label>
            <select
              value={formData.preferences?.Materials_you_are_interested_in_irons || ''}
              onChange={(e) => updateNestedField('preferences', {
                Materials_you_are_interested_in_irons: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="cast_iron">Cast Iron</option>
              <option value="forged">Forged</option>
              <option value="others">Others</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Materials Interested In (Drivers)</label>
            <select
              value={formData.preferences?.Materials_you_are_interested_in_drivers || ''}
              onChange={(e) => updateNestedField('preferences', {
                Materials_you_are_interested_in_drivers: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="carbon_fiber">Carbon Fiber</option>
              <option value="titanium">Titanium</option>
              <option value="others">Others</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Adjustable Driver Lofts</label>
            <select
              value={formData.preferences?.Shiftable_Lofts_drivers?.toString() || ''}
              onChange={(e) => updateNestedField('preferences', {
                Shiftable_Lofts_drivers: e.target.value === 'true' ? true : e.target.value === 'false' ? false : undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Bendable Irons (can change loft and lie later)</label>
            <select
              value={formData.preferences?.Bendable_irons?.toString() || ''}
              onChange={(e) => updateNestedField('preferences', {
                Bendable_irons: e.target.value === 'true' ? true : e.target.value === 'false' ? false : undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>
      </div>

      {/* Brand & Aesthetic Preferences */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Brand & Aesthetic Preferences</h4>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Brand Preferences</label>
            <textarea
              value={formData.preferences?.brand_preferences || ''}
              onChange={(e) => updateNestedField('preferences', {
                brand_preferences: e.target.value || undefined
              })}
              placeholder="Any specific brand preferences or brands you prefer (e.g., TaylorMade, Titleist, Callaway, etc.)"
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
              rows={2}
            />
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Aesthetic Preferences</label>
            <textarea
              value={formData.preferences?.aesthetic_preferences || ''}
              onChange={(e) => updateNestedField('preferences', {
                aesthetic_preferences: e.target.value || undefined
              })}
              placeholder="Any aesthetic or visual preferences for equipment appearance"
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
              rows={2}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab6Preferences;
